import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 14, onChange, testid }) => (
  <div className="flex items-center gap-0.5" data-testid={testid}>
    {[1, 2, 3, 4, 5].map((n) => {
      const on = n <= Math.round(value);
      const icon = <Star size={size} className={on ? "fill-amber-500 text-amber-500" : "text-zinc-700"} />;
      return onChange ? (
        <button key={n} type="button" onClick={() => onChange(n)} className="p-0.5 hover:scale-110 transition-transform" data-testid={`${testid}-${n}`}>
          {icon}
        </button>
      ) : (
        <span key={n}>{icon}</span>
      );
    })}
  </div>
);
